//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
export default {
  components: {},
  data() {
    return {
      operation: 'create',
      listData: [],
      count: 0,
      jobData: [],
      roleData: [],
      appOptions: [],
      statusOption: [0, 1, 2],
      formObj: {},
      operateUserId: 0,
      oldSearchObj: {},
      searchObj: {
        appid: Number(this.$route.query.appid) || 0,
        keyword: this.$route.query.keyword,
        page: Number(this.$route.query.page) || 1,
        page_size: Number(this.$route.query.page_size) || 10,
      },
      rules: {
        name: [
          {
            required: true,
            message: '请输入用户名',
            trigger: 'blur',
          },
        ],
        account: [
          {
            required: true,
            message: '请输入账户',
            trigger: 'blur',
          },
        ],
      },
      defaultJobProps: {
        children: 'children',
        label: 'name',
      },
      jobDialogVisible: false,
      defaultRoleProps: {
        children: 'children',
        label: 'name',
      },
      roleDialogVisible: false,
      opDialogVisible: false,
      submitDisable: false,
      mainJoboptions: [],
      mainJob: '',
      mainJobCode: '',
      jobChecked: [],
      // 用户标签弹窗
      tagDialog: {
        visible: false,
        loading: false,
        tagList: [],
      },
    };
  },
  computed: {
    ...mapGetters('user', ['getElementList']),
    jurisdiction() {
      const jurisdictionArray = [
        'personnelUser_userPermissions_edit',
        'personnelUser_userPermissions_post',
        'personnelUser_userPermissions_role',
        'personnelUser_userPermissions_delete',
      ];
      const jurisdictionObj = {};
      for (const item of jurisdictionArray) {
        jurisdictionObj[item] = this.getElementList.includes(item);
      }

      return jurisdictionObj;
    },
    // jurisdiction() {
    //   return {
    //     userManage: this.getElementList.includes('user-manage'),
    //   };
    // },
    mainJobValue: {
      get() {
        return this.mainJob;
      },
      set(newVal) {
        this.mainJobCode = newVal;
        const index = this.mainJoboptions.findIndex((item) => item.code === newVal);
        this.mainJob = this.mainJoboptions[index].name;
      },
    },
  },
  watch: {
    searchObj: {
      handler() {
        if (this.timer) {
          clearTimeout(this.timer);
        }
        if (this.oldSearchObj.page && this.oldSearchObj.page === this.searchObj.page) {
          this.searchObj.page = 1;
        }
        this.oldSearchObj = Object.assign({}, this.searchObj);
        this.timer = setTimeout(() => {
          this.$router.push({ query: this.searchObj });
          sessionStorage.setItem('app_id', this.searchObj.appid);
          this.loadListData();
          this.loadJobData();
          this.loadRoleData();
        }, 300);
      },
      deep: true,
    },
  },
  mounted() {
    if (!this.searchObj.appid) {
      this.searchObj.appid = Number(sessionStorage.getItem('app_id'));
    } else {
      sessionStorage.setItem('app_id', this.searchObj.appid);
    }
    this.loadAppOption();
    this.loadListData();
    this.loadJobData();
    this.loadRoleData();
  },
  methods: {
    cancelJob() {
      this.jobDialogVisible = false;
      this.mainJoboptions = [];
      this.mainJob = ' ';
      this.mainJobCode = '';
    },
    jobTreeCheck(obj) {
      this.mainJoboptions = this.$refs.jobTree.getCheckedNodes();
      if (this.mainJoboptions.length === 1) {
        this.mainJob = obj.name;
        this.mainJobCode = obj.code;
      }
      const mainJobIndex = this.jobChecked.findIndex((item) => item.priority === 0);
      if (
        mainJobIndex !== -1 &&
        this.mainJoboptions.some((item) => item.id === this.jobChecked[mainJobIndex].id)
      ) {
        this.mainJob = this.jobChecked[mainJobIndex].name;
        this.mainJobCode = this.jobChecked[mainJobIndex].code;
      }
      if (this.mainJoboptions.every((item) => item.name !== this.mainJob)) {
        this.mainJob = this.mainJoboptions.length > 0 ? this.mainJoboptions[0].name : ' ';
        this.mainJobCode = this.mainJoboptions.length > 0 ? this.mainJoboptions[0].code : '';
      }
    },
    loadListData() {
      const url = this.$api.getUserList;
      const data = {
        keyword: this.searchObj.keyword,
        page: this.searchObj.page,
        page_size: this.searchObj.page_size,
      };
      const cb = (data) => {
        this.count = data.total;
        this.listData = data.data;
      };
      this.$request({ url, data, cb });
    },
    loadJobData() {
      const url = this.$api.getJobTree;
      const data = { appid: this.searchObj.appid };
      const cb = (data) => {
        this.jobData = data.data;
      };
      this.$request({ url, data, cb });
    },
    loadJobCheckData() {
      const url = this.$api.getUserJob;
      const data = {
        appid: this.searchObj.appid,
        user_id: this.operateUserId,
      };
      const cb = (data) => {
        this.jobChecked = data.data;
        this.$refs.jobTree.setCheckedKeys(data.data.map((v) => v.id));
      };
      this.$request({ url, data, cb });
    },
    loadRoleData() {
      const url = this.$api.getRoleTree;
      const data = { appid: this.searchObj.appid };
      const cb = (data) => {
        this.roleData = data.data;
      };
      this.$request({ url, data, cb });
    },
    loadRoleCheckData() {
      const url = this.$api.getUserRole;
      const data = {
        appid: this.searchObj.appid,
        user_id: this.operateUserId,
      };
      const cb = (data) => {
        this.$refs.roleTree.setCheckedKeys(data.data.map((v) => v.id));
      };
      this.$request({ url, data, cb });
    },
    loadAppOption() {
      const url = this.$api.getAppList;
      const data = { page_size: 999999 };
      const cb = (data) => {
        this.appOptions = data.data;
        this.searchObj.appid = this.searchObj.appid || this.appOptions[0].id;
      };
      this.$request({ url, data, cb });
    },
    submitForm() {
      if (this.submitDisable) {
        return;
      }
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.opDialogVisible = false;
        this.submitDisable = true;
        const { id } = this.formObj;
        const url = id ? this.$api.updateUser : this.$api.createUser;
        const msg = id ? '修改成功' : '创建成功';
        let data = {};
        if (id) {
          data = {
            id,
            name: this.formObj.name,
            description: this.formObj.description,
          };
        } else {
          data = {
            name: this.formObj.name,
            account: this.formObj.account,
            description: this.formObj.description,
          };
        }

        const cb = () => {
          this.submitDisable = false;
          this.$message({
            message: msg,
            type: 'success',
          });
          this.loadListData();
        };
        const type = 'post';
        this.$request({ url, data, cb, type });
      });
    },
    deleteOperation(id) {
      const url = this.$api.deleteUser;
      const type = 'post';
      const cb = () => {
        this.$message({
          message: '删除成功',
          type: 'success',
        });
        this.loadListData();
      };
      this.$request({ url, cb, type, data: { id } });
    },
    handleAdd() {
      this.operation = 'create';
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.formObj = {};
      this.opDialogVisible = true;
    },
    handleEdit(index, data) {
      this.operation = 'update';
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.formObj = Object.assign({}, data);
      this.opDialogVisible = true;
    },
    handleDelete(index, data) {
      this.$confirm('是否删除该用户?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.deleteOperation(data.id);
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    async handleDetail(index, { id }) {
      this.tagDialog.visible = true;
      this.tagDialog.loading = true;
      try {
        const { tags } = await this.$request({
          url: this.$api.getUserTagInfo,
          data: {
            user_id: id,
            appid: this.searchObj.appid,
          },
        });
        this.tagDialog.tagList = tags;
        this.tagDialog.loading = false;
      } catch (err) {
        this.tagDialog.tagList = [];
        this.tagDialog.loading = false;
        console.log(err);
      }
    },
    handleJob(index, data) {
      this.operateUserId = data.id;
      this.loadJobCheckData();
      this.jobDialogVisible = true;
    },
    jobChange() {
      console.log('node :>> ', this.$refs.jobTree.getCheckedNodes());
    },
    saveJob() {
      const url = this.$api.updateUserJob;
      const type = 'post';

      const nodes = this.$refs.jobTree.getCheckedNodes();
      const data = {
        appid: this.searchObj.appid,
        user_id: this.operateUserId,
        job_codes: nodes.map((v) => v.code),
        prefer_job_code: `${this.mainJobCode}`,
      };
      const cb = () => {
        this.jobDialogVisible = false;
        this.$message({
          message: '保存岗位成功',
          type: 'success',
        });
        this.loadListData();
      };
      this.$request({ url, cb, type, data });
    },
    handleRole(index, data) {
      this.operateUserId = data.id;
      this.loadRoleCheckData();
      this.roleDialogVisible = true;
    },
    saveRole() {
      const url = this.$api.updateUserRole;
      const type = 'post';

      const nodes = this.$refs.roleTree.getCheckedNodes();

      const data = {
        appid: this.searchObj.appid,
        user_id: this.operateUserId,
        role_codes: nodes.map((v) => v.code),
      };
      const cb = () => {
        this.roleDialogVisible = false;
        this.$message({
          message: '保存角色成功',
          type: 'success',
        });
        this.loadListData();
      };
      this.$request({ url, cb, type, data });
    },
  },
};
